import React from 'react'

export default function Wallet() {
  return (
    <div>Wallet</div>
  )
}
